import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import router from './router';
import store from './store/index';

// Services
import Auth from '@/services/Auth';
import Brand from '@/services/Brand';

// Global Components
import App from './App.vue';

// Global Mixins
import '@/mixins/Brand.ts';
import '@/mixins/Agency.ts';

// Libraries
import { init as SentryInit, captureException as SentryCaptureException } from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import 'bootstrap';
import '@stripe/stripe-js';

// Polyfills
// import Es6Promise from 'es6-promise';
// Es6Promise.polyfill();
// import 'promise-polyfill';
import 'whatwg-fetch';

// Primarily for Safari, because as of Jan 2020 the EventTarget constructor is not supported. IE
// doesn't support it at all.
import EventTarget from '@ungap/event-target';
window.EventTarget = EventTarget;

// Confirations
import './axios';
import './plugins';
import './routing';

Vue.config.productionTip = false;

SentryInit({
	dsn: 'https://6a0e6a8ccedf4277bf990e824ffe885a@sentry.io/1384264',
	integrations: [new Integrations.Vue({ Vue, attachProps: true })],
	environment: process.env.VUE_APP_ENV_TYPE,
	attachStacktrace: true,
	release: process.env.VUE_APP_VERSION_COMMIT_ID,
});

// Global App Vars
window.changePassword = false;
window.isLoggedIn = false;
window.sidebarCheckBalance = false;
window.sidebarGetPolicyInfo = false;
window.newUserRegistered = false;
window.jwplayer = () => null;

async function load_script() {
	try {
		let script = document.createElement('script');

		const routesToIgnoreBanner = ['/livechat'];
		const ignoreBanner = routesToIgnoreBanner.includes(window.location.pathname);
		if (!ignoreBanner && Brand.getOneTrustSrc()) {
			script.setAttribute('src', Brand.getOneTrustSrc());
			script.setAttribute('type', 'text/javascript');
			script.setAttribute('charset', 'UTF-8');
			document.head.appendChild(script);

			script = document.createElement('script');
			script.setAttribute('type', 'text/javascript');
			script.innerHTML = 'function OptanonWrapper() {}';
			document.head.appendChild(script);
		}

		if ( process.env.VUE_APP_ENV_TYPE === 'production' ) {
			const crazyegg = document.createElement('script');
			crazyegg.setAttribute('src', 'https://script.crazyegg.com/pages/scripts/0101/6031.js');
			crazyegg.setAttribute('type', 'text/javascript');
			crazyegg.setAttribute('charset', 'UTF-8');
			crazyegg.setAttribute('async', 'async');
			document.head.appendChild(crazyegg);
		}
	} catch (e) {
		SentryCaptureException(e);
	}
}

async function resumeSession() {
	// Determine whether to ignore any existing session based on the current route. `this.$route` isn't yet
	// reflecting the incoming route (its value is '/' at this point), but window.location.pathname is accurate.
	const routesToIgnoreExistingSession = ['/verifycode'];
	const ignoreExistingSession = routesToIgnoreExistingSession.includes(window.location.pathname);

	/**
	 * Check to see if the user is logged in already, "persisted storage"
	 */
	const resumeExistingSession = !ignoreExistingSession;
	if (resumeExistingSession) {
		try {
			// @ts-ignore
			await Auth.resumeSession();
		} catch (e) {
			// To be or not to be...
		}
	}
}

Vue.use(VueGtm, {
  id: Brand.getGtmId(),
  enabled: true,
  debug: false, // Enable if needed
  vueRouter: router,
  ignoredViews: [], // Route names to ignore.
});

(async () => {
	await resumeSession();
	await load_script();

	new Vue({
		router,
		store,
		render: h => h(App),
	}).$mount('#app');
})();
